import React from "react";
import { getBaseProps } from "./helper-methods";
import { Bar } from "./bar";
import { Helpers, VictoryLabel, VictoryContainer, VictoryTheme, addEvents, Data, Domain, UserProps } from "victory-core";
const fallbackProps = {
  width: 450,
  height: 300,
  padding: 50
};
const defaultData = [{
  x: 1,
  y: 1
}, {
  x: 2,
  y: 2
}, {
  x: 3,
  y: 3
}, {
  x: 4,
  y: 4
}];

// eslint-disable-next-line @typescript-eslint/no-empty-interface

/**
 * Draw SVG bar charts with React. VictoryBar is a composable component, so it doesn"t include axes
 * Check out VictoryChart for complete bar charts and more.
 */
class VictoryBarBase extends React.Component {
  static animationWhitelist = ["data", "domain", "height", "padding", "style", "width"];
  static displayName = "VictoryBar";
  static role = "bar";
  static defaultTransitions = {
    onLoad: {
      duration: 2000,
      before: () => ({
        _y: 0,
        _y1: 0,
        _y0: 0
      }),
      after: datum => ({
        _y: datum._y,
        _y1: datum._y1,
        _y0: datum._y0
      })
    },
    onExit: {
      duration: 500,
      before: () => ({
        _y: 0,
        yOffset: 0
      })
    },
    onEnter: {
      duration: 500,
      before: () => ({
        _y: 0,
        _y1: 0,
        _y0: 0
      }),
      after: datum => ({
        _y: datum._y,
        _y1: datum._y1,
        _y0: datum._y0
      })
    }
  };
  static defaultProps = {
    containerComponent: /*#__PURE__*/React.createElement(VictoryContainer, null),
    data: defaultData,
    dataComponent: /*#__PURE__*/React.createElement(Bar, null),
    groupComponent: /*#__PURE__*/React.createElement("g", {
      role: "presentation"
    }),
    labelComponent: /*#__PURE__*/React.createElement(VictoryLabel, null),
    samples: 50,
    sortOrder: "ascending",
    standalone: true,
    theme: VictoryTheme.grayscale
  };
  static getDomain = Domain.getDomainWithZero;
  static getData = Data.getData;
  static getBaseProps(props) {
    return getBaseProps(props, fallbackProps);
  }
  static expectedComponents = ["dataComponent", "labelComponent", "groupComponent", "containerComponent"];

  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist,
      role
    } = VictoryBar;
    const props = Helpers.modifyProps(this.props, fallbackProps, role);
    if (this.shouldAnimate()) {
      return this.animateComponent(props, animationWhitelist);
    }
    const children = this.renderData(props);
    const component = props.standalone ? this.renderContainer(props.containerComponent, children) : children;
    return UserProps.withSafeUserProps(component, props);
  }
}
export const VictoryBar = addEvents(VictoryBarBase);